const sFX = async (file) => {
    let audio = new Audio(`/app/assets/audio/${file}`)
    try {
        await audio.play()
    } catch (err) {
        console.log(`Issue loading sound effect: ${file} - ${err}`)
    }
}

export { sFX }